document.addEventListener('DOMContentLoaded', () => {

// --- NEW CODE FOR DESKTOP TABS ---
const tabBtns = document.querySelectorAll('.tab-btn');
const tabContents = document.querySelectorAll('.tab-content');

tabBtns.forEach(button => {
button.addEventListener('click', () => {
const targetId = button.dataset.target;
const targetContent = document.getElementById(targetId);

// Remove active class from all buttons and content
tabBtns.forEach(btn => btn.classList.remove('active'));
tabContents.forEach(content => content.classList.remove('active'));

// Add active class to the clicked button and its content
button.classList.add('active');
if (targetContent) {
targetContent.classList.add('active');
}

// Sync dropdown text
const dropdownSelectedSpan = document.querySelector('.custom-dropdown .selected span');
if(dropdownSelectedSpan) {
dropdownSelectedSpan.textContent = button.textContent;
}
});
});


// --- EXISTING CODE FOR MOBILE DROPDOWN ---
const dropdown = document.querySelector('.custom-dropdown');
const selected = dropdown.querySelector('.selected');
const options = dropdown.querySelector('.options');
const optionItems = dropdown.querySelectorAll('.options div');

// Toggle dropdown
selected.addEventListener('click', () => {
dropdown.classList.toggle('open');
});

// Option click
optionItems.forEach(option => {
option.addEventListener('click', () => {
const targetId = option.dataset.target;

selected.querySelector('span').textContent = option.textContent;
dropdown.classList.remove('open');

// Sync with tabs (this part is correct)
tabContents.forEach(content => content.classList.remove('active'));
tabBtns.forEach(btn => btn.classList.remove('active'));

const activeBtn = document.querySelector(`.tab-btn[data-target="${targetId}"]`);
const activeContent = document.getElementById(targetId);

if (activeBtn) activeBtn.classList.add('active');
if (activeContent) activeContent.classList.add('active');
});
});

// Click outside → close
document.addEventListener('click', (e) => {
if (!dropdown.contains(e.target)) {
dropdown.classList.remove('open');
}
});

});